// Tipos e rótulos do módulo Meu Imóvel — porte do legado
// SGT.WebUI/src/PortalContribuinte/modulos/meu-imovel/types/meu-imovel.types.ts
// (enums TIPO_IMOVEL:10-15, STATUS_IMOVEL:17-21, SITUACAO_AVALIACAO:23-27,
// helpers de rótulo:122-136 e formatInscricao:138-142). Shapes em snake_case,
// como o backend novo devolve (apps/backend-portal/src/meu-imovel/routes.ts).

export interface ImovelList {
  id: number;
  inscricao: string | null;
  tipo_enum: number;
  status_enum: number;
  logradouro: string | null;
  numero_porta: string | null;
  bairro: string | null;
  area_lote: number;
  area_construida_unidade: number;
  responsavel: string | null;
  cpf_cnpj: string | null;
}

export interface ImovelDetalhe extends ImovelList {
  complemento: string | null;
  lote: string | null;
  quadra: string | null;
  lado: string | null;
  referencia: string | null;
  tipo_pessoa: string | null;
  imovisento_iptu: boolean;
  imovisento_tsu: boolean;
  desmembramento: boolean;
  inscricao_anterior: string | null;
  registro_cart: string | null;
  observacoes: string | null;
  condominio: string;
  secao: number;
  zona_enum: number;
}

export interface Proprietario {
  id: number;
  nome: string | null;
  cpf_cnpj: string | null;
  percentual: number;
}

export interface CaracteristicaImovel {
  id: number;
  item: string | null;
  valor: string | null;
}

export interface ValorDeclarado {
  id: number;
  exercicio: string | null;
  valor: number;
}

export interface AvaliacaoImovel {
  id: number;
  exercicio: string | null;
  vvt: number;
  vve: number;
  vvi: number;
  area_lote: number;
  area_construida: number;
  aliquota: number;
  valor_iptu: number;
  taxa_coleta_lixo: number;
  taxa_esgoto: number;
  situacao: number;
  finalidade: number;
  data_avaliacao: string | null;
}

const TIPO_IMOVEL: Record<number, string> = {
  1: 'TERRITORIAL',
  2: 'PREDIAL',
  3: 'CONDOMÍNIO HORIZONTAL',
  4: 'CONDOMÍNIO VERTICAL',
};

const STATUS_IMOVEL: Record<number, string> = {
  1: 'ATIVO',
  2: 'DESATIVADO',
  3: 'BLOQUEADO',
};

const SITUACAO_AVALIACAO: Record<number, string> = {
  1: 'AVALIADA',
  2: 'COM ERROS',
  3: 'ISENÇÃO/IMUNIDADE',
};

const FINALIDADE_AVALIACAO: Record<number, string> = {
  1: 'IPTU',
  2: 'ITBI',
};

export function getTipoImovelLabel(codigo: number): string {
  return TIPO_IMOVEL[codigo] ?? 'DESCONHECIDO';
}

export function getStatusImovelLabel(codigo: number): string {
  return STATUS_IMOVEL[codigo] ?? 'DESCONHECIDO';
}

export function getSituacaoAvaliacaoLabel(codigo: number): string {
  return SITUACAO_AVALIACAO[codigo] ?? 'DESCONHECIDO';
}

export function getFinalidadeAvaliacaoLabel(codigo: number): string {
  return FINALIDADE_AVALIACAO[codigo] ?? 'DESCONHECIDO';
}

// Máscara da inscrição imobiliária (legado meu-imovel.types.ts:138-142).
export function formatInscricao(inscricao: string | null): string {
  if (!inscricao || inscricao.length < 14) {
    return inscricao ?? '';
  }
  const limpa = inscricao.replace(/\D/g, '');
  return `${limpa.slice(0, 2)}-${limpa.slice(2, 4)}-${limpa.slice(4, 7)}-${limpa.slice(7, 11)}-${limpa.slice(11, 14)}`;
}

export function formatCurrency(valor: number): string {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatArea(valor: number): string {
  return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
